'use client';

import { Theme } from '@radix-ui/themes';
import { useAppSelector } from '@/app/lib/store/hooks';
import { THEME } from '@/app/lib/constants/config';

interface Props {
  children: React.ReactNode;
}

export default function ClientThemeProvider({ children }: Props) {
  const themeMode = useAppSelector(state => state.theme.mode);

  return (
    <Theme
      appearance={themeMode}
      accentColor='jade'
      grayColor='slate'
      radius={THEME.radius}
      style={{ backgroundColor: 'transparent' }}
    >
      {children}
    </Theme>
  );
}
